export default "assets/images/a-ne-pas-manquer-en-4069ba48.svg";